import categories from '~~/data/content/categories.json'
import { normalize } from '~~/utils'

export default function ({ query, params, redirect }) {
  const { c = 0 } = query

  const oldCategorySelected = categories.find(cat => cat.id == c)

  if (oldCategorySelected?.id) {
    const { c, ...newQuery } = query

    return redirect(
      `/products/category/${normalize(oldCategorySelected.name)}`,
      newQuery
    )
  }
}
